export default theme => ({
  root: {
    width: '100px'
  },
});

